import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 border-y-4 border-sun bg-mist" data-id="element-121" data-mp="17ws2s9xeyodg">
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-6" data-id="element-122" data-mp="1mmqxg2prfho6">
        <p className="inline-block rounded-full bg-electric px-3 py-0.5 font-display text-[0.66rem] font-extrabold uppercase tracking-[0.18em] text-white sm:text-xs" data-id="element-123" data-mp="1hph266fowbsf">
          SPECIAL LAUNCH OFFER
        </p>
        <h2 className="mt-1.5 font-display text-[1.5rem] font-extrabold uppercase leading-none text-navy sm:text-[2.1rem]" data-id="element-124" data-mp="p11xacq9v9ut">
          🏊 POOL &amp; SPA <span className="text-electric" data-id="element-125" data-mp="yxxydxductpc">DIAGNOSTIC PRO™</span>
        </h2>
        <p className="mt-1 font-display text-[0.66rem] font-extrabold uppercase text-navy/70 sm:text-[0.82rem]" data-id="element-126" data-mp="ywmyi8nio63i">
          THE COMPLETE POOL &amp; SPA TROUBLESHOOTING &amp; REPAIR SYSTEM
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[270px] sm:max-w-[340px]" target="checkout" data-id="element-127" data-mp="2af7hgit25jq4" />

        <div className="mt-2 rounded-lg border-2 border-sun bg-navy px-3 py-3 text-left shadow-lg" data-id="element-128" data-mp="pjz4ly943o0d">
          <p className="text-center font-display text-base font-extrabold uppercase text-aqua sm:text-xl" data-id="element-129" data-mp="uhh4kz55isw8">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-130" data-mp="13k9w93i8x6ml">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5 text-[0.76rem] leading-tight text-white sm:text-[0.86rem]" data-id="element-131" data-mp="6uir8acbw12j">
                <span aria-hidden="true" data-id="element-132" data-mp="btc2dw457fzj">✅</span>
                <span data-id="element-133" data-mp="funx2g1virel">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2.5 text-center font-display text-[0.8rem] font-extrabold uppercase leading-tight text-white sm:text-[1rem]" data-id="element-134" data-mp="fskvqzv9tbuk">
            🔥 GET POOL &amp; SPA DIAGNOSTIC PRO™ TODAY —{' '}
            <span className="whitespace-nowrap rounded bg-sun px-1.5 text-navy" data-id="element-135" data-mp="3k6t3o5k3ov78">$27 USD</span>
          </p>
          <div className="mt-2.5" data-id="element-136" data-mp="vfqwo0z3taro">
            <CTAButton label="🏊 GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-137" data-mp="vez3ewszbp4k" />
          </div>
          <p className="mt-2 text-center text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-138" data-mp="qfup5rr7717d">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}